import { ComponentType, FunctionComponent, useEffect, useState } from "react";

interface QRCodeProps {
  value: string;
  size?: number;
}

interface Props {
  value: string;
  size?: number;
}

/** Loads react-qr-code on demand so it stays out of the prod client bundle. */
const DevDeviceQrCode: FunctionComponent<Props> = ({ value, size = 140 }) => {
  const [QRCode, setQRCode] = useState<ComponentType<QRCodeProps> | null>(null);

  useEffect(() => {
    let cancelled = false;
    void import("react-qr-code").then((mod) => {
      if (!cancelled) {
        setQRCode(() => mod.default);
      }
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!QRCode) {
    return null;
  }

  return <QRCode value={value} size={size} />;
};

export default DevDeviceQrCode;
